import { type FunctionComponent, } from "react"
import { useEscrowStore } from "@stores/escrow";
import { Dollars, } from "@components";
import { getChainInfo, } from "@bracket/addressbook";
import { getConnectionInfoMaybe, } from "@helpers";

import "./TotalStaked.scss";


export declare type TotalStakedProps = {

};


export const TotalStaked: FunctionComponent<TotalStakedProps> = ({

}) => {

	const classes = () => [ `total-staked` ].join(" ");
	const { user_stake, user_stake_chain, } = useEscrowStore();
	const { chain, } = getConnectionInfoMaybe();
	const { label, } = chain ? getChainInfo(chain) : { label: "None", };

	return (
		<section className={classes()}>
			<div className="title par-xl-20">You've Staked</div>
			<div className="value par-xl-20-mono"><Dollars value={user_stake_chain} loading={user_stake < 0} />&nbsp;{label}</div>
		</section>
	);

}
